@if (showHeader()) {
	<h3>
		<fa-icon [icon]="faCopy"></fa-icon>
		{{ "Neue Nachricht" | translate }}
	</h3>
}
@if (showMessageTypeSelection()) {
	<div class="message-types-row">
		<lib-message-types [messageType]="messageType()" (newMessageType)="onNewMessageType($event)" />
	</div>
}
<lib-comment
	[type]="messageType()"
	[htmlContent]="message()"
	[showTypeHeader]="showMessageTypeSelection()"
	(valueChanges)="onMessageChange($event)"
></lib-comment>
<button mat-raised-button [disabled]="isSendButtonDisabled()" (click)="onSubmit()">
	{{ "Absenden" | translate }}
</button>
